export enum LoggingMode {
  Local = "local", //z logowaniem
  Guest = "guest", //rezerwacja jako gość
  Sso = "sso", //logowanie sso
}
